module.exports = __webpack_public_path__ + "static/profile-samir-9b99b9bdd27c3ff7974bb8220ca8281f.jpg";